import React from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
} from '@mui/material';
import InputConsensus from 'components/InputConsensus';
import { useParameterKeys } from 'hooks/useParameterKeys';

const FulfilledIdForm = ({
  installment,
  fulfilled,
  setFulfilled,
  externalMonitoring,
  setExternalMonitoring,
  fulfilledId,
  setFulfilledId,
  wasPaid = false,
  useGrid = false,
}) => {
  const { isMPDFT } = useParameterKeys();

  const handleFulfilledIdChange = (e) => {
    let val = e.target.value.replace(/\D/g, '').slice(0, 6);
    setFulfilledId(val);
  };

  const handleFulfilledChange = (e) => {
    setFulfilled(e.target.checked);
    if (!e.target.checked) setFulfilledId('');
  };

  const handleExternalMonitoringChange = (e) => {
    setExternalMonitoring(e.target.checked);
  };

  if (useGrid) {
    return (
      <Grid container spacing={2}>
        {installment?.attendanceOfJudgement ? (
          <>
            <Grid size={12}>
              <FormControlLabel
                style={{ width: '100%' }}
                control={
                  <Checkbox
                    checked={fulfilled}
                    onChange={handleFulfilledChange}
                    name="fulfilled"
                    color="primary"
                    disabled={externalMonitoring}
                  />
                }
                label="Comparecimento cumprido"
              />
            </Grid>
            {fulfilled && (
              <Grid size={12}>
                <Box display="flex" alignItems="center" mt={1} marginLeft={4}>
                  <InputConsensus
                    label="ID"
                    onChange={handleFulfilledIdChange}
                    value={fulfilledId}
                    name="fulfilledId"
                    variant="outlined"
                    size="small"
                    placeholder="999999"
                    inputProps={{ maxLength: 6 }}
                  />
                </Box>
              </Grid>
            )}
            <Grid size={12}>
              <FormControlLabel
                style={{ width: '100%', marginTop: 10 }}
                control={
                  <Checkbox
                    checked={externalMonitoring}
                    onChange={handleExternalMonitoringChange}
                    name="externalMonitoring"
                    color="primary"
                    disabled={fulfilled}
                  />
                }
                label="Acompanhamento pela vara"
              />
            </Grid>
          </>
        ) : (
          <Grid size={12}>
            <InputConsensus
              label="ID"
              onChange={handleFulfilledIdChange}
              value={fulfilledId}
              name="fulfilledId"
              variant="outlined"
              size="small"
              placeholder="999999"
              inputProps={{ maxLength: 6 }}
            />
          </Grid>
        )}
      </Grid>
    );
  }

  // Renderização sem Grid (para ModalConfirm)
  if (installment?.attendanceOfJudgement && !wasPaid) {
    return (
      <Box display="flex" flexDirection="column" mt={2} gap={1} marginLeft={2}>
        <FormControlLabel
          style={{ width: '100%' }}
          control={
            <Checkbox
              checked={fulfilled}
              onChange={handleFulfilledChange}
              name="fulfilled"
              color="primary"
              disabled={externalMonitoring}
            />
          }
          label="Comparecimento cumprido"
        />
        {fulfilled && !wasPaid && (
          <Box display="flex" alignItems="center" mt={1} marginLeft={4}>
            <InputConsensus
              label="ID"
              onChange={handleFulfilledIdChange}
              value={fulfilledId}
              name="fulfilledId"
              variant="outlined"
              size="small"
              placeholder="999999"
              inputProps={{ maxLength: 6 }}
            />
          </Box>
        )}
        <FormControlLabel
          style={{ width: '100%', marginTop: 10 }}
          control={
            <Checkbox
              checked={externalMonitoring}
              onChange={handleExternalMonitoringChange}
              name="externalMonitoring"
              color="primary"
              disabled={fulfilled}
            />
          }
          label="Acompanhamento pela vara"
        />
      </Box>
    );
  }

  if (isMPDFT && !installment?.attendanceOfJudgement && !wasPaid) {
    return (
      <Box display="flex" alignItems="center" mt={2}>
        <InputConsensus
          label="ID"
          onChange={handleFulfilledIdChange}
          value={fulfilledId}
          name="fulfilledId"
          variant="outlined"
          size="small"
          placeholder="999999"
          inputProps={{ maxLength: 6 }}
        />
      </Box>
    );
  }

  return null;
};

export default FulfilledIdForm;